import React from "react";

function PercentInput({
  value,
  onChange,
  error,
  validated,
  label = "Indiquez le pourcentage de votre congé",
  id = "percent",
  name = "percent",
  required = true,
}) {
  return (
    <div>
      <label
        htmlFor={id}
        style={{
          fontSize: "0.875rem",
          fontWeight: 600,
          color: error ? "#ba1a1a" : validated ? "#198754" : "#414751",
          display: "block",
          marginBottom: "0.5rem",
        }}
      >
        {label}
      </label>
      <div style={{ display: "flex", alignItems: "stretch" }}>
        <input
          type="number"
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          pattern="\d{1,2}(\.\d{1,2})?"
          onWheel={(e) => e.target.blur()}
          required={required}
          min={0}
          max={100}
          style={{
            flex: 1,
            backgroundColor: "#ffffff",
            border: error
              ? "1.5px solid #ba1a1a"
              : validated
                ? "1.5px solid #198754"
                : "none",
            borderRight: "none",
            borderRadius: "0.5rem 0 0 0.5rem",
            padding: "0.75rem",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            outline: "none",
            fontSize: "0.95rem",
            fontFamily: "Inter, sans-serif",
            minWidth: 0,
          }}
        />
        <span
          style={{
            backgroundColor: "#f2f3fe",
            border: error
              ? "1.5px solid #ba1a1a"
              : validated
                ? "1.5px solid #198754"
                : "none",
            borderLeft: "1px solid #e2e4ea",
            borderRadius: "0 0.5rem 0.5rem 0",
            padding: "0.75rem 1rem",
            fontWeight: 600,
            color: "#414751",
            fontSize: "0.95rem",
            display: "flex",
            alignItems: "center",
          }}
        >
          %
        </span>
      </div>
      {error && (
        <p style={{ color: "#ba1a1a", fontSize: "0.8rem", marginTop: "0.25rem" }}>
          {error}
        </p>
      )}
    </div>
  );
}

export default PercentInput;
